var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('div',{staticClass:"v-label"},[_vm._t("default"),_c('i',{staticClass:"ss-pc icon-clear",on:{"click":function($event){return _vm.$emit('remove')}}})],2)}
var staticRenderFns = []

export { render, staticRenderFns }